import { defineMessages } from 'react-intl'

export const textWithShowMoreMessages = defineMessages({
  showMore: {
    id: 'textWithShowMoreMessages.ShowMoreLabel',
    description: 'Show more label for button in text block',
    defaultMessage: 'Show More',
  },
  showLess: {
    id: 'textWithShowMoreMessages.ShowLessLabel',
    description: 'Show less label for button in text block',
    defaultMessage: 'Show Less',
  },
})
